/**
 *订单域枚举常量定义
 *基于订单域API契约文档定义
 */

//订单状态
export const ORDER_STATUS = {
  CREATED: 'CREATED',           //已创建
  IN_PROGRESS: 'IN_PROGRESS',   //进中
  COMPLETED: 'COMPLETED',       //已完成
  CANCELLED: 'CANCELLED',       // 已取消
  OUTBOUND_COMPLETED: 'OUTBOUND_COMPLETED', // 出库完成
  RETURN: 'RETURN',             // 退货
};

//订单状态显示映射
export const ORDER_STATUS_OPTIONS = [
  { value: ORDER_STATUS.CREATED, label: 'order.status.created', color: 'blue' },
  { value: ORDER_STATUS.IN_PROGRESS, label: 'order.status.inProgress', color: 'processing' },
  { value: ORDER_STATUS.COMPLETED, label: 'order.status.completed', color: 'green' },
  { value: ORDER_STATUS.OUTBOUND_COMPLETED, label: 'order.status.outboundCompleted', color: 'green' },
  { value: ORDER_STATUS.CANCELLED, label: 'order.status.cancelled', color: 'red' },
  { value: ORDER_STATUS.RETURN, label: 'order.status.return', color: 'gold' },
];

// 订单类型
export const ORDER_TYPE = {
  SAME_DAY: 'SAME_DAY',        // 当日达
  NEXT_DAY: 'NEXT_DAY',        //达
};

export const ORDER_TYPE_OPTIONS = [
  { value: ORDER_TYPE.SAME_DAY, label: 'order.type.sameDay' },
  { value: ORDER_TYPE.NEXT_DAY, label: 'order.type.nextDay' },
];

//渠
export const CHANNEL = {
  LOTUS: 'LOTUS',               // Lotus's
  AMAZE: 'AMAZE',               // Amaze
  AXTRA_MALL: 'AXTRA_MALL',     // Axtra mall
};

export const CHANNEL_OPTIONS = [
  { value: CHANNEL.LOTUS, label: "Lotus's" },
  { value: CHANNEL.AMAZE, label: 'Amaze' },
  { value: CHANNEL.AXTRA_MALL, label: 'Axtra Mall' },
];

//支付方式
export const PAYMENT_METHOD = {
  POD: 'POD',                           // 货到付款-现金
  POD_DIGITAL_WALLET: 'POD_DIGITAL_WALLET', // 货到付款-电子钱包
  POLCC: 'POLCC',                        // 在线支付-信用卡
  POLTMW: 'POLTMW',                     // 在线支付-TrueMoney
};

export const PAYMENT_METHOD_OPTIONS = [
  { value: PAYMENT_METHOD.POD, label: 'POD (Cash on Delivery)' },
  { value: PAYMENT_METHOD.POD_DIGITAL_WALLET, label: 'POD (Digital Wallet)' },
  { value: PAYMENT_METHOD.POLCC, label: 'Credit Card' },
  { value: PAYMENT_METHOD.POLTMW, label: 'TrueMoney Wallet' },
];

// 拣选模式 (Picking Mode)
export const PICKING_MODE = {
  ORDER_PICKING: 'ORDER_PICKING',       // 按单拣选
  BATCH_PICKING: 'BATCH_PICKING',       // 批量拣选
  MANUAL_PICKING: 'MANUAL_PICKING',     // 手工拣选
};

export const PICKING_MODE_OPTIONS = [
  { value: PICKING_MODE.ORDER_PICKING, label: 'order.pickingMode.orderPicking' },
  { value: PICKING_MODE.BATCH_PICKING, label: 'order.pickingMode.batchPicking' },
  { value: PICKING_MODE.MANUAL_PICKING, label: 'order.pickingMode.manualPicking' },
];

// 支付类型 (Payment Type)
export const PAYMENT_TYPE = {
  CASH: 'CASH',                 // 现金
  CREDIT_CARD: 'CREDIT_CARD',   // 信用卡
  E_WALLET: 'E_WALLET',         // 电子钱包
  BANK_TRANSFER: 'BANK_TRANSFER', // 银行转账
};

export const PAYMENT_TYPE_OPTIONS = [
  { value: PAYMENT_TYPE.CASH, label: 'Cash' },
  { value: PAYMENT_TYPE.CREDIT_CARD, label: 'Credit Card' },
  { value: PAYMENT_TYPE.E_WALLET, label: 'E-Wallet' },
  { value: PAYMENT_TYPE.BANK_TRANSFER, label: 'Bank Transfer' },
];

// 订单明细状态
export const ORDER_ITEM_STATUS = {
  PENDING: 'PENDING',           // 待拣
  PICKED: 'PICKED',             // 已拣
  SHORTAGE: 'SHORTAGE',         // 缺货
  SUBSTITUTED: 'SUBSTITUTED',   // 已替换
  CANCELED: 'CANCELED',         // 已取消（商品不再进行拣选，拣选数量为0）
  REPICKED: 'REPICKED',         // 重新拣选（调整了拣选数量）
  CONFIRMED_SHORT: 'CONFIRMED_SHORT', // 确认缺货（商品数量为0，实际拣选数量为0，已确认）
};

export const ORDER_ITEM_STATUS_OPTIONS = [
  { value: ORDER_ITEM_STATUS.PENDING, label: 'order.itemStatus.pending', color: 'default' },
  { value: ORDER_ITEM_STATUS.PICKED, label: 'order.itemStatus.picked', color: 'green' },
  { value: ORDER_ITEM_STATUS.SHORTAGE, label: 'order.itemStatus.shortage', color: 'red' },
  { value: ORDER_ITEM_STATUS.SUBSTITUTED, label: 'order.itemStatus.substituted', color: 'orange' },
  { value: ORDER_ITEM_STATUS.CANCELED, label: 'order.itemStatus.canceled', color: 'default' },
  { value: ORDER_ITEM_STATUS.REPICKED, label: 'order.itemStatus.repicked', color: 'blue' },
  { value: ORDER_ITEM_STATUS.CONFIRMED_SHORT, label: 'order.itemStatus.confirmedShort', color: 'red' },
];

//缺货原因（value 与后端/PDA 端存储的 code 保持一致）
export const SHORTAGE_REASON = {
  OUT_OF_STOCK: 'STOCK_OH_ZERO_OR_NEGATIVE',      //库存为0或负数
  NOT_FOUND: 'HAS_STOCK_BUT_NOT_FOUND',           // 有库存但找不到
  INSUFFICIENT: 'INSUFFICIENT_QUANTITY',          // 数量不足
  QUALITY_ISSUE: 'QUALITY_UNSUITABLE_OR_EXPIRED', //质量问题/过期
  NO_IMAGE: 'NO_IMAGE_OR_NAME_ON_APP',            // APP未显示图片或名称
  CUSTOMER_REQUEST: 'CUSTOMER_CHANGE_PRODUCT',    //客户要求更换
  CUSTOMER_PROCESS: 'CUSTOMER_TRIMMING_COOKING',  //客户要求加工/烹饪
};

export const SHORTAGE_REASON_OPTIONS = [
  { value: SHORTAGE_REASON.OUT_OF_STOCK, label: 'order.shortageReason.outOfStock' },
  { value: SHORTAGE_REASON.NOT_FOUND, label: 'order.shortageReason.notFound' },
  { value: SHORTAGE_REASON.INSUFFICIENT, label: 'order.shortageReason.insufficient' },
  { value: SHORTAGE_REASON.QUALITY_ISSUE, label: 'order.shortageReason.qualityIssue' },
  { value: SHORTAGE_REASON.NO_IMAGE, label: 'order.shortageReason.noImage' },
  { value: SHORTAGE_REASON.CUSTOMER_REQUEST, label: 'order.shortageReason.customerRequest' },
  { value: SHORTAGE_REASON.CUSTOMER_PROCESS, label: 'order.shortageReason.customerProcess' },
];

//取消类型（value 与后端 CancelType 枚举 code 保持一致）
export const CANCEL_TYPE = {
  CANCEL_BY_PHOENIX: 'CANCEL_BY_PHOENIX',           //上游系统取消
  CANCEL_BY_CUSTOMER: 'CANCEL_BY_CUSTOMER',         //顾客取消
  CANCEL_BY_PICKING_TOOL: 'CANCEL_BY_PICKING_TOOL', //拣货员取消
};

export const CANCEL_TYPE_OPTIONS = [
  { value: CANCEL_TYPE.CANCEL_BY_PHOENIX, label: 'order.cancelType.cancelByPhoenix' },
  { value: CANCEL_TYPE.CANCEL_BY_CUSTOMER, label: 'order.cancelType.cancelByCustomer' },
  { value: CANCEL_TYPE.CANCEL_BY_PICKING_TOOL, label: 'order.cancelType.cancelByPickingTool' },
];

//客户确认状态
export const CUSTOMER_CONFIRM_STATUS = {
  PENDING: 'PENDING',           // 待确认
  CONFIRMED: 'CONFIRMED',       //已同意
  REJECTED: 'REJECTED',         //已拒绝
};

export const CUSTOMER_CONFIRM_STATUS_OPTIONS = [
  { value: CUSTOMER_CONFIRM_STATUS.PENDING, label: 'order.confirmStatus.pending', color: 'orange' },
  { value: CUSTOMER_CONFIRM_STATUS.CONFIRMED, label: 'order.confirmStatus.confirmed', color: 'green' },
  { value: CUSTOMER_CONFIRM_STATUS.REJECTED, label: 'order.confirmStatus.rejected', color: 'red' },
];

//导出所有枚举对象（用于统一访问）
export const ORDER_ENUMS = {
  ORDER_STATUS,
  ORDER_TYPE,
  CHANNEL,
  PAYMENT_METHOD,
  ORDER_ITEM_STATUS,
  SHORTAGE_REASON,
  CANCEL_TYPE,
  CUSTOMER_CONFIRM_STATUS,
};

export default ORDER_ENUMS;